import { render, staticRenderFns } from "./ArtifactGroup.vue?vue&type=template&id=6466039c&scoped=true&"
import script from "./ArtifactGroup.vue?vue&type=script&lang=js&"
export * from "./ArtifactGroup.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactGroup.vue?vue&type=style&index=0&id=6466039c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466039c",
  null
  
)

export default component.exports